var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      ref: "ticketDialog",
      attrs: {
        title: "异常改签-确认行程信息",
        visible: _vm.detailShow,
        "close-on-click-modal": false,
        "before-close": _vm.handleClose,
        "append-to-body": true,
        width: "68%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.detailShow = $event
        },
      },
    },
    [
      _c(
        "el-descriptions",
        { attrs: { title: "原班次信息", column: 3 } },
        [
          _c("el-descriptions-item", { attrs: { label: "班次时间" } }, [
            _vm._v(_vm._s(_vm.sourceInfoVo.departureTime)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "司机信息" } }, [
            _vm._v(_vm._s(_vm.sourceInfoVo.driver)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "车辆信息" } }, [
            _vm._v(_vm._s(_vm.sourceInfoVo.car)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "取件费" } }, [
            _vm._v(_vm._s(_vm.sourceInfoVo.receiveFee || "-")),
          ]),
          _c("el-descriptions-item", { attrs: { label: "运输费" } }, [
            _vm._v(_vm._s(_vm.sourceInfoVo.transportationFee || "-")),
          ]),
          _c("el-descriptions-item", { attrs: { label: "派件费" } }, [
            _vm._v(_vm._s(_vm.sourceInfoVo.sendFee || "-")),
          ]),
          _c("el-descriptions-item", { attrs: { label: "下单人手机号" } }, [
            _vm._v(_vm._s(_vm.sourceInfoVo.mobilePhone)),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "padding-top": "20px" } },
        [
          _c(
            "el-descriptions",
            { attrs: { title: "新班次信息", column: 3 } },
            [
              _c("el-descriptions-item", { attrs: { label: "班次时间" } }, [
                _vm._v(_vm._s(_vm.newInfo.departureTime)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "司机信息" } }, [
                _vm._v(_vm._s(_vm.newInfo.driver)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "车辆信息" } }, [
                _vm._v(_vm._s(_vm.newInfo.car)),
              ]),
              _c("el-descriptions-item", { attrs: { label: "取件费" } }, [
                _vm._v(_vm._s(_vm.newInfo.receiveFee || "-")),
              ]),
              _c("el-descriptions-item", { attrs: { label: "运输费" } }, [
                _vm._v(_vm._s(_vm.newInfo.transportationFee || "-")),
              ]),
              _c("el-descriptions-item", { attrs: { label: "派件费" } }, [
                _vm._v(_vm._s(_vm.newInfo.sendFee || "-")),
              ]),
              _c("el-descriptions-item", { attrs: { label: "下单人手机号" } }, [
                _vm._v(_vm._s(_vm.newInfo.mobilePhone)),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "padding-top-20" },
        [
          _c("el-descriptions", { attrs: { title: "物品信息" } }),
          _c("goodsInfo", {
            attrs: { expressOrderDetails: _vm.changeInfo.expressOrderDetails },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass:
            "margin-y-15 font-light font-16 required position-relative",
        },
        [_vm._v("改签说明")]
      ),
      _c("el-input", {
        attrs: {
          type: "textarea",
          placeholder: "请填写改签说明",
          rows: 4,
          maxlength: "100",
          "show-word-limit": "",
        },
        model: {
          value: _vm.remarksBackstage,
          callback: function ($$v) {
            _vm.remarksBackstage = $$v
          },
          expression: "remarksBackstage",
        },
      }),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "danger" },
              on: { click: _vm.cancel },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v("确认改签")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }